import { applyTokens } from "../../../utilities/applyTokens.js";
const createStates = (state) => {
    const { defaultState, hover, active, disabled } = state;
    return Object.assign(Object.assign({}, applyTokens(defaultState)), { "&:not(.Mui-disabled):hover": Object.assign({}, applyTokens(hover)), "&:not(.Mui-disabled):active": Object.assign({}, applyTokens(active)), "&.Mui-disabled": Object.assign({}, applyTokens(disabled)) });
};
const menu = (tokens) => {
    const { component: { menu }, semantic, } = tokens;
    const { default: defaultState, hover, active, disabled, destructive: { default: destructiveDefault, hover: destructiveHover, active: destructiveActive, disabled: destructiveDisabled, }, icon, } = menu.item;
    return {
        MuiMenu: {
            styleOverrides: {
                paper: {
                    backgroundColor: menu.backgroundColor.value,
                    borderRadius: menu.borderRadius.value,
                    boxShadow: menu.boxShadow.value.stringValue,
                },
                list: {
                    paddingTop: 0,
                    paddingBottom: 0,
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: ({ ownerState }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, applyTokens(menu.item)), { "&:first-of-type": {
                        borderTopLeftRadius: menu.borderRadius.value,
                        borderTopRightRadius: menu.borderRadius.value,
                    }, "&:last-of-type": {
                        borderBottomLeftRadius: menu.borderRadius.value,
                        borderBottomRightRadius: menu.borderRadius.value,
                    } }), createStates({
                    defaultState,
                    hover,
                    active,
                    disabled,
                })), (ownerState.color === "destructive" && Object.assign({}, createStates({
                    defaultState: destructiveDefault,
                    hover: destructiveHover,
                    active: destructiveActive,
                    disabled: destructiveDisabled,
                })))), { "&:focus": {
                        boxShadow: semantic.shadow.focusInset.value.stringValue,
                        outlineOffset: "-2px",
                    }, ".MuiListItemIcon-root": {
                        minWidth: "initial",
                        color: "inherit",
                        "& > svg": {
                            width: icon.width.value,
                            height: icon.height.value,
                            fontSize: icon.width.value,
                            lineHeight: icon.height.value,
                        },
                    } })),
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: menu.backgroundColor.value,
                    borderRadius: menu.borderRadius.value,
                    boxShadow: menu.boxShadow.value.stringValue,
                    "& .MuiList-root": {
                        paddingTop: 0,
                        paddingBottom: 0,
                    },
                },
            },
        },
    };
};
export default menu;
//# sourceMappingURL=menu.js.map